import xhrService from "../xhrService";

export interface InspectionTemplateType {
  id: number;
  name: string;
}

export const inspectionTemplateTypesApi = {
  index: (): Promise<InspectionTemplateType[]> =>
    xhrService
      .get(`/api/inspection-template-types`)
      .then(res => res.data.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      }),
  
  getUniqueByProject: (projectId: number): Promise<InspectionTemplateType[]> =>
    xhrService
      .get(`/api/projects/${projectId}/inspection-template-types/unique`)
      .then(res => res.data.data)
      .catch(({ response }) => {
        throw new Error(response.data.message);
      }),

  getAvailableTypes: (
    templateId: number
  ): Promise<{ types: InspectionTemplateType[]; currentTypeId: number | null }> =>
    xhrService
      .get(`/api/inspection-templates/${templateId}/all-available-types`)
      .then(res => ({
        types: res.data.data as InspectionTemplateType[],
        currentTypeId: (res.data.current_type_id as number) ?? null,
      }))
      .catch(({ response }) => {
        throw new Error(response.data.message);
      }),
};

export default inspectionTemplateTypesApi;